module.exports = {
      id: "canvas-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#canvas",
      toString: function () {
        return this.url;
      }
    }